// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1AhsK","loaderOuter":"PageOverlayLoader_loaderOuter__1hUlc"};